import React from "react";
import ZhengyiJiang from './../assets/avatars/ZhengyiJiang.jpg'
import TingRen from './../assets/avatars/TingRen.jpg'

const OrganisingCommitteeChair = () => {

  const organisingCommitteeChairs = [
    {
      pic: ZhengyiJiang,
      name: "Zhengyi Jiang (Chair)",
      position: "Distinguished Professor",
      affiliation: "University of Wollongong",
      url: "https://scholars.uow.edu.au/zhengyi-jiang/"
    },
    {
      pic: TingRen,
      name: "Ting Ren (Co-chair)",
      position: "Professor",
      affiliation: "University of Wollongong",
      url: "https://scholars.uow.edu.au/ting-ren/"
    },
  ]

  return (
    <div className="flex flex-row flex-wrap content-start items-center justify-around">
      {[...organisingCommitteeChairs].map((chair, index) => {
        return (
          chair.url ? 
          <a href={chair.url} key={`organisingCommitteeChairs-${index}`} className="hover:opacity-80" target="_blank" rel="noreferrer">
          <div className="md:w-48 w-36 m-4 md:m-8">
            <img className="w-full" src={chair.pic} alt={`avatar-${chair.name}-${index}`} 
             style={{ height: '200px', objectFit: 'cover', borderRadius: '50%' }} />
            <div style={{ fontWeight: 'bold' }}>{chair.name}</div>
            <div>{chair.position}</div>
            <div style={{ fontWeight: 'bold' }}>{chair.affiliation}</div>
          </div>
          </a>
          :
          <span key={`organisingCommitteeChairs-${index}`}>
          <div className="md:w-48 w-36 m-4 md:m-8">
            <img className="w-full" src={chair.pic} alt={`avatar-${chair.name}-${index}`} 
             style={{ height: '200px', objectFit: 'cover', borderRadius: '50%' }} />
            <div style={{ fontWeight: 'bold' }}>{chair.name}</div>
            <div>{chair.position}</div>
            <div style={{ fontWeight: 'bold' }}>{chair.affiliation}</div>
          </div>
          </span>
        )
      })}
    </div>
);
}

export default OrganisingCommitteeChair;
